import { render, staticRenderFns } from "./Order_detail.vue?vue&type=template&id=9f3a208e"
import script from "./Order_detail.vue?vue&type=script&lang=js"
export * from "./Order_detail.vue?vue&type=script&lang=js"
import style0 from "./Order_detail.vue?vue&type=style&index=0&id=9f3a208e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports